import React from 'react';

import { postMessageRN, runningInRNWebView, WebToRNAction } from '@eika-infrastruktur/mobilbank-lib';
import { LinkButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import { DarkSkeleton } from '@eika/skeleton';

import ANALYTICS_CATEGORIES from '../../analytics/categories';
import { useEfakturaLink } from '../../fetchHooks/useEfaktura';
import type { EFakturaId } from '../../generated-types';
import useTranslation from '../../hooks/useTranslation';
import { AnalyticsEvents, trackEvent } from '../../services/analytics';

export interface Props {
    eFakturaId?: EFakturaId;
    className?: string;
    loading?: boolean;
    disabled?: boolean;
}

const EfakturaLink: React.FC<Props> = ({ eFakturaId, className, loading, disabled }) => {
    const translated = useTranslation();
    const { data: eFakturaUrl, isLoading } = useEfakturaLink(eFakturaId);

    const showEfaktura = async () => {
        trackEvent(AnalyticsEvents.EFAKTURA, ANALYTICS_CATEGORIES.EFAKTURA, 'preview_efaktura');
        if (!eFakturaUrl) {
            return;
        }
        if (runningInRNWebView) {
            postMessageRN({ action: WebToRNAction.OPEN_EFAKTURA, payload: eFakturaUrl });
        } else {
            window.open(eFakturaUrl, 'menubar=no,location=no,resizable=yes,scrollbars=yes,status=yes,noopener');
        }
    };

    if ((isLoading || loading) && !eFakturaUrl) {
        return (
            <div className={className}>
                <DarkSkeleton height={28} width={115} />
            </div>
        );
    }

    if (!eFakturaUrl) return null;

    return (
        <LinkButton className={className} icon={IconTypes.E_FAKTURA_LOGO_24} onClick={showEfaktura} disabled={disabled}>
            {translated.viewEFaktura}
        </LinkButton>
    );
};

export default EfakturaLink;
